<button (click)="showPage()">
  Clique
</button>